// extracted by mini-css-extract-plugin
export var container = "_am-0";
export var icon = "_am-1";
export var text = "_am-2";